import { handleToggle } from './planHelpers';

export * from './planSelectors';
export const SET_DATA = 'mp/plan/SET_DATA';
export const TOGGLE_DETAILS = 'mp/plan/TOGGLE_DETAILS';
export const TOGGLE_CHANNEL = 'mp/plan/TOGGLE_CHANNEL';

export const initialState = {
  loaded: false,
  isPlanAvailable: true,
  servicePackages: {},
  currentPlan: {},
  totalAmount: {},
  channels: [],
  additionalServices: [],
  charges: {},
  equipment: [],
  eligibility: {},
  addAdjustCapability: {},
  lobs: {
    TV: {
      serviceName: "XFINITY TV"
    },
    Internet: {
      serviceName: "XFINITY Internet"
    },
    Voice: {
      serviceName: "XFINITY Voice"
    },
    Home: {
      serviceName: "XFINITY Home Security"
    }
  }
};

export const plan = (state = initialState, action = {}) => {
  switch (action.type) {

    case SET_DATA:
      return {
        ...state,
        ...action.payload
      };

    case TOGGLE_DETAILS: {
      return {
        ...state,
        servicePackages: {
          packages: handleToggle(state.servicePackages.packages, action.planName)
        }
      };
    }

    case TOGGLE_CHANNEL: {
      return {
        ...state,
        channels: handleToggle(state.channels, action.channelName)
      };
    }

    default:
      return state;
  }
};

export const toggleDetails = (planName) => {
  return {
    type: TOGGLE_DETAILS,
    planName
  };
};

export const toggleChannelDetails = (channelName) => {
  return {
    type: TOGGLE_CHANNEL,
    channelName
  };
};

export default plan;



/** WEBPACK FOOTER **
 ** ./client/redux/modules/data/plan/plan.js
 **/